// import * as XLSX from "xlsx";
// import { isPlainObject } from "./isPlainObject";

// export const exportToExcel = (gridRef, projectTitle = "") => {
//   const rowData = [];

//   const columns = gridRef.current.api.getAllDisplayedColumns().map((col) => ({
//     field: col.getColDef().field,
//     headerName: col.getColDef().headerName,
//   }));

//   gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
//     const row = {};
//     columns.forEach((col) => {
//       row[col.headerName] = isPlainObject(node.data[col.field])
//         ? node.data[col.field].value
//         : node.data[col.field];
//     });

//     rowData.push(row);
//   });

//   const worksheet = XLSX.utils.json_to_sheet(rowData);

//   const workbook = XLSX.utils.book_new();

//   XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

//   XLSX.writeFile(workbook, `${projectTitle}.xlsx`);
// };
import ExcelJS from "exceljs";
import { isPlainObject } from "./isPlainObject";

export const exportToExcel = async (gridRef, projectTitle = "") => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Data");

  const columns = gridRef.current.api.getAllDisplayedColumns().map((col) => ({
    field: col.getColDef().field,
    headerName: col.getColDef().headerName,
  }));

  // Заголовки
  worksheet.columns = columns.map((col) => ({
    header: col.headerName,
    key: col.headerName,
    width: 10,
  }));

  gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
    const rowValues = {};

    columns.forEach((col) => {
      const rawValue = node.data?.[col.field];

      const value = isPlainObject(rawValue) ? rawValue.value : rawValue;

      rowValues[col.headerName] = value;
    });

    // додаємо рядок
    const row = worksheet.addRow(rowValues);

    //коментарі

    columns.forEach((col, index) => {
      const rawValue = node.data?.[col.field];

      if (isPlainObject(rawValue) && rawValue.comment) {
        const cell = row.getCell(index + 1);

        cell.note = rawValue.comment;
      }
    });
  });

  //стиль header
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(1).alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${projectTitle || "export"}.xlsx`;
  link.click();

  window.URL.revokeObjectURL(url);
};
